<template>
  <div v-show="isLogin" class="lnb menuDiv">
    <nav>
      <ul>
        <li v-show="isLogin" :class="{'on': menuName == 'DashBoard' }">
          <a href="javascript:;" @click="goPage('DashBoard')"><span class="icon dashboard"></span>대시보드</a>
        </li>
        <li :class="{'on': menuName == 'EntryApplicationGuide' }" @click="goPage('EntryApplicationGuide')">
          <a href="javascript:;"><span class="icon ic_lnbbtn_2"></span>상품 입점 신청</a>
        </li>
        <li v-show="isLogin" :class="{'on': menuName == 'EntryApplicationList' }">
          <a href="javascript:;" @click="goPage('EntryApplicationList')"><span class="icon inquiry"></span>상품 입점 처리
            조회</a>
        </li>
        <li v-show="isLogin" :class="!menuOpen ? 'collapse open' : 'collapse'">
          <!-- collapse의 경우 open : 펼치기, 접기 제어  /  on : 활성화 표시 -->
          <button type="button" @click="menuOpen = !menuOpen"><span class="icon management"></span>상품 등록 관리</button>
          <div class="depth2">
            <ul>
              <li :class="{'on': menuName == 'ProductStatus' }"><a href="javascript:;" @click="goPage('ProductStatus')">상품
                출시 현황</a></li>
              <li :class="{'on': menuName == 'ImageStatus' }"><a href="javascript:;" @click="goPage('ImageStatus')">상품
                이미지 관리</a></li>
              <!-- <li :class="{'on': menuName == 'PromotionCreateList' }"><a href="javascript:;" @click="goPage('PromotionCreateList')" >프로모션 관리</a></li>
              <li :class="{'on': menuName == 'PromotionHistList' }"><a href="javascript:;" @click="goPage('PromotionHistList')" >프로모션 이력</a></li> -->
              <li :class="{'on': menuName == 'BannerCreate' }"><a href="javascript:;" @click="goPage('BannerCreate')">띠
                배너 관리</a></li>
            </ul>
          </div>
        </li>
        <li v-show="isLogin" :class="{'on': menuName == 'SubscriptionList' }" @click="goPage('SubscriptionList')">
          <a href="javascript:;"><span class="icon history"></span>상품 신청 · 이용 내역</a>
        </li>
        <li v-show="isLogin" :class="{'on': menuName == 'BillingList' }" @click="goPage('BillingList')">
          <a href="javascript:;"><span class="icon billing"></span>고객 청구/정산 내역 조회</a>
        </li>
        <li v-show="isLogin" :class="{'on': menuName == 'ManagerInfo' }">
          <a href="javascript:;" @click="goPage('ManagerInfo')"><span class="icon information"></span>가입 정보</a>
        </li>
        <li :class="{'on': menuName == 'NoticeList' }">
          <a href="javascript:;" @click="goPage('NoticeList')"><span class="icon notice"></span>공지사항</a>
        </li>
      </ul>
    </nav>
    <div>
      <!-- 2025.01.14 FJB System 수정 -->
      <div class="bn_wrap" v-if="surveyBoolean">
        <router-link :to="{ name : 'SurveyForm' }" target="_blank">
          <div>
            <p>kt cloud 마켓플레이스</p>
            <h4 class="tit">제휴사 대상 설문조사</h4>
            <img src="@/assets/img/icon/ic-banner-arrow.svg" alt="">
          </div>
          <ul>
            <li><span>기간</span>2025.1.27 까지</li>
            <li><span>혜택</span>홈화면에 상품 홍보 배너 2개월 간 게시</li>
          </ul>
        </router-link>
      </div>
      <!-- // 2025.01.14 FJB System 수정 -->
      <div :class="!isSiteDropdown ? 'dropup lg black' : 'dropup lg black on'" class="dropup lg black" data-hd-dropdown
           @click="isSiteDropdown = !isSiteDropdown">
        <button data-dropdown-btn type="button">kt cloud 이동 링크</button>
        <ul>
          <li><a href="https://cloud.kt.com" target='_blank'>기업용 kt cloud <img alt=""
                                                                               src="@/assets/img/icon/ic_link_list.svg"></a>
          </li>
          <li><a href="https://gcloud.kt.com" target='_blank'>공공용 kt cloud <img alt=""
                                                                                src="@/assets/img/icon/ic_link_list.svg"></a>
          </li>
          <li><a href="https://cloud.kt.com/marketplace" target='_blank'>기업용 마켓플레이스 <img
              alt="" src="@/assets/img/icon/ic_link_list.svg"></a></li>
          <li><a href="https://gcloud.kt.com/marketplace" target='_blank'>공공용 마켓플레이스 <img
              alt="" src="@/assets/img/icon/ic_link_list.svg"></a></li>
          <li v-show="salesMaterialYn == 'Y'"><a href="/salesMaterial/SalesMaterial" target='_blank'>Sales Material <img
              alt="" src="@/assets/img/icon/ic_link_list.svg"></a></li>
        </ul>
      </div>
    </div>
  </div>
  <!-- 공공 비로그인 -->
  <div v-show="!isLogin && type != 'enterprise' && isBanner" class="lnb menuDiv">
    <div class="lnb_banner">
      <img alt="" src="@/assets/img/img_banner_public_lnb.png">
    </div>
    <div>
      <div :class="!isSiteDropdown ? 'dropup lg black' : 'dropup lg black on'" class="dropup lg black" data-hd-dropdown
           @click="isSiteDropdown = !isSiteDropdown">
        <button data-dropdown-btn type="button">kt cloud 이동 링크</button>
        <ul>
          <li><a href="https://cloud.kt.com" target='_blank'>기업용 kt cloud <img alt=""
                                                                               src="@/assets/img/icon/ic_link_list.svg"></a>
          </li>
          <li><a href="https://gcloud.kt.com" target='_blank'>공공용 kt cloud <img alt=""
                                                                                src="@/assets/img/icon/ic_link_list.svg"></a>
          </li>
          <li><a href="https://cloud.kt.com/marketplace" target='_blank'>기업용 마켓플레이스 <img
              alt="" src="@/assets/img/icon/ic_link_list.svg"></a></li>
          <li><a href="https://gcloud.kt.com/marketplace" target='_blank'>공공용 마켓플레이스 <img
              alt="" src="@/assets/img/icon/ic_link_list.svg"></a></li>
          <li v-show="salesMaterialYn == 'Y'"><a href="/salesMaterial/SalesMaterial" target='_blank'>Sales Material <img
              alt="" src="@/assets/img/icon/ic_link_list.svg"></a></li>
        </ul>
      </div>
    </div>
  </div>
  <!-- 기업 비로그인 -->
  <div v-show="!isLogin && type == 'enterprise' && isBanner" class="lnb menuDiv">
    <div class="lnb_banner">
      <img alt="" src="@/assets/img/img_banner_enterprise_lnb.png">
    </div>
    <div>
      <div :class="!isSiteDropdown ? 'dropup lg black' : 'dropup lg black on'" class="dropup lg black" data-hd-dropdown
           @click="isSiteDropdown = !isSiteDropdown">
        <button data-dropdown-btn type="button">kt cloud 이동 링크</button>
        <ul>
          <li><a href="https://cloud.kt.com" target='_blank'>기업용 kt cloud <img alt=""
                                                                               src="@/assets/img/icon/ic_link_list.svg"></a>
          </li>
          <li><a href="https://gcloud.kt.com" target='_blank'>공공용 kt cloud <img alt=""
                                                                                src="@/assets/img/icon/ic_link_list.svg"></a>
          </li>
          <li><a href="https://cloud.kt.com/marketplace" target='_blank'>기업용 마켓플레이스 <img
              alt="" src="@/assets/img/icon/ic_link_list.svg"></a></li>
          <li><a href="https://gcloud.kt.com/marketplace" target='_blank'>공공용 마켓플레이스 <img
              alt="" src="@/assets/img/icon/ic_link_list.svg"></a></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import {inject, onBeforeMount, reactive, toRefs} from "vue";
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import commonMgt from "@/assets/js/marketPartnerCommon.js";
import moment from "moment";

export default {
  name : 'Menu',
  setup: () => {
    const router = useRouter();
    const emitter = inject("emitter");
    const store = useStore();
    const {common} = commonMgt();
    const state = reactive({
      menuName       : "",
      isLogin        : false,
      menuOpen       : false,
      isSiteDropdown : false,
      type           : process.env.VUE_APP_POTAL_MARKET_TYPE,
      isBanner       : false,
      salesMaterialYn: "",
      surveyBoolean  : false // 마켓 개선사항 설문조사 배너 노출여부
    });
    const goPage = (name) => {
      state.menuName = name
      if (name != "ProductStatus"
          && name != "PromotionCreateList"
          && name != "PromotionHistList"
          && name != "BannerCreate"
          && name != "ImageStatus"
      ) {
        state.menuOpen = true;
      }
      router.push({
        name: name,
      });
    }

    emitter.on("isBanner", (value) => {
      state.isBanner = value;
    });

    emitter.on("menuName", (value) => {
      state.menuName = value;
      if (value != "ProductStatus"
          && value != "PromotionCreateList"
          && value != "BannerCreate"
          && value != "ImageStatus"
      ) {
        state.menuOpen = true;
      } else {
        state.menuOpen = false;
      }
    });

    onBeforeMount(() => {
      var authorization = store.getters["staLogin/getPartnerAccessToken"];

      if (!common.isEmpty(authorization)) {
        state.isLogin = true;
      }
      var codeList = common.getCode('SALES_SHOW_YN');
      codeList.then((value) => {
        state.salesMaterialYn = value[0].code
      });

      // 마켓 기능 개선 설문조사 배너 날짜 체크
      var codeList = common.getCode("SURVEY_DATE");
      codeList.then((value) => {
        const currentDate = moment(); // 현재 날짜 및 시간
        const stdate = moment(value[0].codeSub, "YYYYMMDDHHmm");
        const eddate = moment(value[0].codeSub2, "YYYYMMDDHHmm");

        const surveyBoolean = currentDate.isBetween(stdate, eddate, undefined, '[]');
        if (surveyBoolean) {
          state.surveyBoolean = surveyBoolean;
        }
      });

    });

    emitter.on("myLogin", (value) => {
      state.isLogin = value;
    });

    emitter.on("menuNone", (value) => {
      state.isLogin = value;
    });

    return {
      ...toRefs(state),
      goPage
    }
  },
}
</script>
